var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container as ContainerComponent } from "@animech/ui";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
var ContainerWithProps = function (props) { return (_jsx(ContainerComponent, __assign({}, props))); };
export var Container = styled(ContainerWithProps)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function () {
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\tmin-width: 500px;\n\t\t"], ["\n\t\t\tmin-width: 500px;\n\t\t"])));
});
var templateObject_1, templateObject_2;
